import { parseContextRef, type Target } from "../store/targets";

/** What a chip, a list row or the lip's "open full page" opens: an application's chat or General. */
export type ChatPick = Exclude<Target, { kind: "thread" }>;

export const ASSISTANT_PATH = "/assistant";

/** Router state that opens /assistant on a chat (the lip's "open full page"). */
export const openOnChat = (pick: ChatPick) => ({ assistantPick: pick });

/** A chat pick from untrusted data (router state, storage); anything else is null. */
export function parsePick(value: unknown): ChatPick | null {
  const pick = value as { kind?: unknown; ref?: unknown } | null | undefined;
  if (pick?.kind === "general") return { kind: "general" };
  const parsed = pick?.kind === "context" ? parseContextRef(pick.ref) : null;
  return parsed ? { kind: "context", ref: parsed.ref } : null;
}

/** The chat a navigation asked /assistant to open; anything else is ignored. */
export function pickFromState(state: unknown): ChatPick | null {
  return parsePick((state as { assistantPick?: unknown } | null)?.assistantPick);
}
